// extracted by mini-css-extract-plugin
export default {"productGrid":"w0-z","centerLink":"x0-z","productSection":"y0-z","item":"z0-z","ctaButton":"A0-z"};